/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: exports a function, not a component. */
import type { RowData } from '@tanstack/react-table';
import type * as React from 'react';

import type { Column } from '../DimeDataTable/DimeDataTable.types.js';

export function getAriaSort(
  column: Pick<Column<RowData>, 'getCanSort' | 'getIsSorted'>,
): React.AriaAttributes['aria-sort'] {
  if (!column.getCanSort()) return undefined;
  const sorted = column.getIsSorted();
  return sorted === 'asc' ? 'ascending' : sorted === 'desc' ? 'descending' : 'none';
}
